import React from 'react';
import { Section, Carousel, OnVisible, Link, Image } from 'components';
import Marquee from 'react-fast-marquee';

import * as styles from './styles.module.scss';

const BrandLogosCarousel = (props) => {
  const { data } = props;
  const { primary, items } = data;

  const { title, description, cta_text: ctaText, cta_link: ctaLink } = primary;

  // content checks
  const titleHtml = title?.html;
  const descriptionHtml = description?.html;
  const hasCta = ctaText?.text && ctaLink?.url;

  return (
    <Section sliceName="BrandLogosCarousel" className={styles.section} containerClassName={styles.container}>
      {items?.[0] && (
        <OnVisible visibleClassName={styles.visible} className={styles.carousel}>
          <Marquee className={styles.marquee} speed={50} gradient={false}>
            {items.map((item, index) => {
              return (
                <div key={index} className={styles.logoContainer}>
                  <Image image={item.logo} className={styles.image} />
                </div>
              );
            })}
          </Marquee>
        </OnVisible>
      )}
      <div className={styles.header}>
        {titleHtml && <div dangerouslySetInnerHTML={{ __html: titleHtml }} className={styles.title} />}
        {descriptionHtml && (
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        )}
        {hasCta && (
          <Link className={`button ${styles.cta}`} to={ctaLink?.url}>
            {ctaText?.text}
          </Link>
        )}
      </div>
    </Section>
  );
};

export default BrandLogosCarousel;
